import { ShapeCirclePlusIcon } from './ShapeCirclePlusIcon';

/**
 * author: Kai Faust
 * id C989421F-7F77-45D9-9BB4-97D3DE8C8FB4
 * name shape-circle-plus
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shape-circle-plus.svg
 * tags
 * - Shape 
 */
export const ShapeCircleAddIcon = ShapeCirclePlusIcon;
export default ShapeCircleAddIcon